export default __webpack_public_path__ + "static/media/no-record-light.f3f6c7cc.svg";